module.exports = __webpack_public_path__ + "img/interests.962b870b.png";